// extracted by mini-css-extract-plugin
export default {"wrapper":"Welcome_wrapper__KRX57","content":"Welcome_content__7WqRv"};